import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChangeEvent, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import Table from "../../../../../Components/Table";
import { ClienteEmLoteInterface } from "../../../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
import { formatedTelefone } from "../../../../../Tools/FormatTools";
import { useComunicadoClienteImportarPlanilhaContext } from "../ComunicadoClienteContext/ComunicadoClienteContext";
import LeiaMais from "../../../../../Components/Utils/LeiaMais";

interface IImportarPanilhaClientes {}

export default function ImportarPanilhaClientes(
    props: IImportarPanilhaClientes
) {
    const { lstClientesPlanilha, setLstClientesPlanilha } =
        useComunicadoClienteImportarPlanilhaContext();

    const [pesquisar, setPesquisa] = useState("");
    const [loading, setLoading] = useState(false);

    const tableviewColumnsPlanilha: Array<
        ColumnDescription<ClienteEmLoteInterface>
    > = [
        {
            dataField: "ID_CONTA",
            text: "",
            isDummyField: true,
        },
        {
            dataField: "NR_TELEFONE",
            text: "Telefone",
            formatter: (c) => (c ? formatedTelefone(c) : "-"),
        },
        {
            dataField: "DS_CONTA",
            text: "Nome",
        },
        {
            dataField: "DS_EMAIL",
            text: "Email",
            formatter: (c) => (
                <LeiaMais customLeiaMais="+" customLeiaMenos="-" charLimit={40}>
                    {c}
                </LeiaMais>
            ),
        },
        {
            dataField: "DS_EMPREENDIMENTO",
            text: "Empreendimento",
        },
        {
            dataField: "DS_BLOCO",
            text: "Bloco",
        },
        {
            dataField: "",
            text: "",
            formatter: (c, row) => (
                <div className="Button-Tools">
                    <button
                        className="btn btn-outline-danger font-weight-bold mr-2"
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja remover este cliente?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            })
                                .then((result) => {
                                    if (result.isConfirmed) {
                                        const updatedList =
                                            lstClientesPlanilha.filter(
                                                (item) =>
                                                    item.ID_CONTA !==
                                                    row.ID_CONTA
                                            );
                                        setLstClientesPlanilha(updatedList);
                                    }
                                })
                                .finally(() => {});
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} size="lg" /> Excluir
                    </button>
                </div>
            ),
        },
    ];

    const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
        const searchTerm = e.target.value;
        setPesquisa(searchTerm);
        setLoading(true);

        setTimeout(() => {
            setLoading(false);
        }, 1000);
    };
    const dadosFiltrados = lstClientesPlanilha.filter((item) => {
        return Object.values(item).some((value) =>
            String(value).toLowerCase().includes(pesquisar.toLowerCase())
        );
    });

    console.log(dadosFiltrados);

    return (
        <>
            <input
                type="text"
                className="form-control"
                value={pesquisar}
                onChange={handleSearch}
                placeholder="Pesquisar"
            />
            <Table
                keyField={"ID_CONTA"}
                data={dadosFiltrados}
                loading={loading}
                columns={tableviewColumnsPlanilha}
                remote={{ pagination: true }}
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum Registro Encontrado
                    </div>
                )}
                sizePerPage={lstClientesPlanilha?.length}
                noPagination
                noHover
                noSearch
                bordered={false}
                defaultStyle={{
                    align: "center",
                    classes: "p-2",
                }}
                striped={true}
            />
        </>
    );
}
